import { CollaborationStepActionIntent } from '@services/collaboration-plan.service';

// База маршруту за типом інтенту (бек описує НАМІР - `actionIntent.type`/`.params`
// з CollaborationStepService, api/.../collaboration-step-type.enum.ts; фронт лише виконує,
// нічого не знає про конкретні типи задач - "тупий" щодо подій при тапі).
const ACTION_INTENT_BASE_ROUTES: Partial<Record<CollaborationStepActionIntent['type'], (clientId: number) => string>> = {
  questionnaires: (clientId) => `/client/${clientId}/questionnaires`,
  appointments: (clientId) => `/client/${clientId}/appointments`,
  calendar: (clientId) => `/client/${clientId}/calendar`,
  chat: (clientId) => `/chat?clientId=${clientId}`,
};

// `params` з інтенту (напр. `{ dateView: 'week' }`) підставляються як query-параметри "в лоб" -
// фронт не інтерпретує, що вони означають.
export const resolveActionNavigation = (intent: CollaborationStepActionIntent, clientId: number): string | null => {
  const buildBase = ACTION_INTENT_BASE_ROUTES[intent.type];
  if (!buildBase) return null;
  const base = buildBase(clientId);
  if (!intent.params || Object.keys(intent.params).length === 0) return base;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}${new URLSearchParams(intent.params).toString()}`;
};
